import { Jaco } from "./Jaco";
import * as Maths3 from "oc-threejs/Maths3";

import type { ITransition } from "./Jaco";
import { Vector3 } from "three";

/**
 * PivotKette ermöglicht die Drehung um eine Drehachse und behandelt
 * dabei rotation und translation intern unabhängig voneinder, was
 * Animationen ermöglicht.
 */
export class PivotKette extends Jaco {
  constructor(parent: Jaco | null) {
    // Chain: PivotKette -> Jaco (Translation) -> Jaco (Rotation) -> Parent
    super(new Jaco(new Jaco(parent)));
  }

  rotateAround(pivotPoint: Vector3, axis: Vector3, angle: number) {
    if (this.parent && this.parent.parent) {
      this.parent.parent.position.copy(pivotPoint);
      this.parent.quaternion.setFromAxisAngle(axis, angle);
      this.position.copy(pivotPoint).negate();
    }
  }

  reset() {
    if (this.parent && this.parent.parent) {
      this.parent.parent.copyMatrix(Maths3.matrix.identity);
    }
    if (this.parent) {
      this.parent.copyMatrix(Maths3.matrix.identity);
    }
    this.copyMatrix(Maths3.matrix.identity);
  }

  set transition(value: ITransition | null) {
    this._transition = value;
    if (this.parent) {
      this.parent.transition = value;
      if (this.parent.parent) {
        this.parent.parent.transition = value;
      }
    }
  }

  get transition(): ITransition | null {
    return this._transition;
  }

  update3d() {
    this.parent.parent.update3d();
    this.parent.update3d();
    super.update3d();
  }

  traverse(iterator: (node: Jaco) => void) {
    if (this.parent) {
      if (this.parent.parent) {
        this.parent.parent.traverse(iterator);
      }
      this.parent.traverse(iterator);
    }
    super.traverse(iterator);
  }
}
